import { logEvent } from '@eventbrite/statsig';
import React, { PureComponent } from 'react';
import { BucketHeader } from '../../../../components/BucketHeader';
import { NearbyCities } from '../../../../shared/nearbyCities';

interface NearbyCitiesBucketProps {
    content: {
        id: string;
        name: string;
        url: string;
        distance: string;
    }[];
    name?: string;
    placeType?: string;
    usesLanguageSubdirectory?: boolean;
    locale?: string;
}

export class NearbyCitiesBucket extends PureComponent<NearbyCitiesBucketProps> {
    _handleTrackClick() {
        logEvent('CityBrowse - nearby_cities - Click - Nearby City');
    }

    render() {
        const { content, name, placeType } = this.props;

        const isCountry = placeType === 'country';

        return (
            <div>
                <BucketHeader title={name} />
                <NearbyCities
                    content={content}
                    handleTrackClick={this._handleTrackClick.bind(this)}
                    isCountry={isCountry}
                    usesLanguageSubdirectory={
                        this.props.usesLanguageSubdirectory
                    }
                    locale={this.props.locale}
                ></NearbyCities>
            </div>
        );
    }
}
